import zod from "zod";
import { z } from "/@/modules/zodUtils";

export const TrainingSchema = z.object({
  id: z.number().optional(),
  title: z.string(),
  publishedAt: z.string().optional(),
  unpublishedAt: z.string().optional(),
  newAttached: z.custom<File>((data) => {
    return data instanceof File;
  }),
  fileName: z.string(), // upploaded file name to gcp e.g. "vides/mp4/aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaaaaa.mp4"
  remarks: z.string().optional(),
});
export type Training = zod.infer<typeof TrainingSchema>;

export const TrainingCheckSchema = TrainingSchema;
export const TrainingUpdateCheckSchema = TrainingSchema.partial({
  newAttached: true,
  fileName: true,
});
export type TrainingUpdateCheck = zod.infer<typeof TrainingUpdateCheckSchema>;

export const TrainingFormSchema = TrainingSchema.partial();
export type TrainingForm = zod.infer<typeof TrainingFormSchema>;

export const TrainingClientSchema = TrainingSchema.pick({
  title: true,
  fileName: true,
  unpublishedAt: true,
  remarks: true,
}).extend({
  id: z.number(),
  organizationId: z.number(),
  published: z.boolean(),
  unpublished: z.boolean(),
  publishedAt: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  attachedUrl: z.string().optional(), // show only show page
  watched: z.boolean(),
  watchedUsers: z
    .object({
      id: z.number(),
      fullName: z.string(),
      organizations: z
        .object({
          id: z.number(),
          name: z.string(),
        })
        .array(),
    })
    .array(),
  organizations: z.object({
    id: z.number(),
    name: z.string(),
  }),
  myTrainingView: z.object({
    id: z.number(),
    watched: z.boolean(),
    watchedMinutes: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
  }),
});
export type TrainingClient = zod.infer<typeof TrainingClientSchema>;
